import { queryClient } from '@portal/queryClient'
import { CancelledError } from '@tanstack/react-query'
import { redirect } from '@tanstack/react-router'
import { DocumentNotFoundError } from '@zealth/core/firebase/firestoreErrors'
import { getShowProfileQueryOptions } from '@zealth/core/profile/api'

// Route loader for paths that require a profile. Preloads the profile
// into the TanStack Query cache so downstream components see it without
// their own loading state. Redirects users without a profile to the
// onboarding flow.
export const ensureProfile = async (): Promise<void> => {
  try {
    await queryClient.ensureQueryData(getShowProfileQueryOptions('default'))
  } catch (err) {
    if (err instanceof DocumentNotFoundError) {
      throw redirect({ to: '/onboarding' })
    }
    // A newer invalidation (e.g. rapid impersonation user-switch) cancelled
    // this in-flight fetch. Don't surface the cancellation as a loader
    // error — the superseding navigation will run its own loader.
    if (err instanceof CancelledError) {
      return
    }
    throw err
  }
}
